import type { RootState } from 'store';

export const getLoading = (state: RootState) => state.common.loading;
export const getCandidateLoading = (state: RootState) => state.common.candidate_loading;
export const getStepsLoading = (state: RootState) => state.common.steps_loading;
export const getOpeningsLoading = (state: RootState) => state.common.openings_loading;
export const getHrManagers = (state: RootState) => state.common.hr_managers;
export const getRecruiterLeads = (state: RootState) => state.common.recruiterLeads;
export const getListHRL = (state: RootState) => state.common.list_hrl;
export const getServices = (state: RootState) => state.common.services;
export const getLocations = (state: RootState) => state.common.locations;
export const getLanguages = (state: RootState) => state.common.languages;
export const getLevels = (state: RootState) => state.common.levels;
export const getPositions = (state: RootState) => state.common.positions;
export const getCompanies = (state: RootState) => state.common.companies;
